import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-lock\"><g id=\"icon-lock_fill\"><path d=\"M18.83,9.7h-.38V5.1A4.61,4.61,0,0,0,13.85.5H10.78a4.61,4.61,0,0,0-4.6,4.6V9.7H5.8a1.15,1.15,0,0,0-1.15,1.15v11.5A1.15,1.15,0,0,0,5.8,23.5h13A1.15,1.15,0,0,0,20,22.35V10.85A1.15,1.15,0,0,0,18.83,9.7Zm-5,10.73H10.78l.67-3.33a1.53,1.53,0,1,1,1.73,0ZM15.38,9.7H9.25V5.1a1.53,1.53,0,0,1,1.53-1.53h3.07A1.53,1.53,0,0,1,15.38,5.1Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol